export const Actions = {
  COOKIES_GET: 'COOKIES/GET',
  COOKIES_SET: 'COOKIES/SET',
  COOKIES_EXPIRE: 'COOKIES/EXPIRE',
  COOKIES_REMOVE: 'COOKIES/REMOVE',
};
